module.exports = __webpack_public_path__ + "static/media/person2.72ea720c.jpeg";